import React from 'react';

import { FormHelp } from '@zillow/constellation-10';

import PeopleInformation from './PeopleInformation';
import { PERSON_TYPE } from '../../../constants/stringConstants';
import type { PeopleSection } from '../../../models/index';

type Props = {
  section: PeopleSection;
  setSection: (section: PeopleSection) => void;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function GuarantorInformation({ section, setSection, setSectionValues }: Props): JSX.Element {
  const maxPeople = 1;

  return (
    <PeopleInformation
      isOptional
      maximumPeople={maxPeople}
      initialPeople={0}
      personType={PERSON_TYPE.GUARANTOR}
      setSectionValues={setSectionValues}
      setSection={setSection}
      section={section}
      label="Will there be a guarantor?"
      description={<FormHelp>A guarantor agrees to be liable if the tenant defaults on the lease</FormHelp>}
      addressLabel="Address"
      yesAndNoText="The signed guaranty must be delivered within 5 days of the lease signing."
    />
  );
}
